import React from "react"
import { Helmet } from "react-helmet"
import { useCompanyBranding } from "../../components/common/useCompanyBranding"

/** Rahmen der öffentlichen Seiten (Anmeldung, Passwort): Logo und Firmenfarbe aus den öffentlichen Endpunkten. */
export default function AuthPageLayout({ title, children }: { title: string; children: React.ReactNode }) {
    const { companyData, logo } = useCompanyBranding()
    return (
        <main className="flex flex-col w-full min-h-screen bg-base-100">
            <Helmet>
                <title>Kundenportal | {title}</title>
            </Helmet>
            <div className="h-2 w-full" style={{ backgroundColor: companyData?.color }} />
            <div className="flex grow items-center justify-center p-4">
                <div className="w-full max-w-md bg-white rounded-default shadow-lg p-8 flex flex-col gap-6">
                    <div className="flex flex-col items-center gap-2">
                        {logo && <img src={logo} alt="Logo" className="max-h-20 object-contain" />}
                        <p className="text-sm font-semibold uppercase tracking-wide" style={{ color: companyData?.color }}>
                            Kundenportal
                        </p>
                    </div>
                    <h1 className="text-2xl font-semibold text-center">{title}</h1>
                    {children}
                </div>
            </div>
        </main>
    )
}

/** Primär-Button in der Firmenfarbe (daisyUI `btn-primary` als Rückfall). */
export function PrimaryButton(props: React.ButtonHTMLAttributes<HTMLButtonElement> & { loading?: boolean }) {
    const { companyData } = useCompanyBranding()
    const { loading, children, className, style, ...rest } = props
    const color = companyData?.color
    return (
        <button
            {...rest}
            className={`btn btn-primary w-full text-white ${className ?? ""}`}
            style={color ? { backgroundColor: color, borderColor: color, ...style } : style}>
            {loading && <span className="loading loading-spinner" />}
            {children}
        </button>
    )
}
